document.addEventListener('DOMContentLoaded', function() {
    const popupBtn = document.querySelector('.custom-popup-btn');
    const popup = document.getElementById('customPopup');
    const closePopupBtn = document.querySelector('.close-popup');

    if (popupBtn && popup && closePopupBtn) {
        popupBtn.addEventListener('click', function() {
            popup.style.display = 'block';
            document.body.classList.add('no-scroll'); // Add no-scroll class
        });

        closePopupBtn.addEventListener('click', function() {
            popup.style.display = 'none';
            document.body.classList.remove('no-scroll'); // Remove no-scroll class
        });

        window.addEventListener('click', function(event) {
            if (event.target == popup) {
                popup.style.display = 'none';
                document.body.classList.remove('no-scroll'); // Remove no-scroll class
            }
        });
    }
});

const openPopupBtn = document.querySelector('button.btn.custom-popup-btn.button.button--solid');
if (openPopupBtn) {
    openPopupBtn.addEventListener('click', function() {
        document.body.style.overflow = 'hidden';
    });
}

const closePopupSpan = document.querySelector('span.close-popup');
if (closePopupSpan) {
    closePopupSpan.addEventListener('click', function() {
        document.body.style.overflow = '';
    });
}

//cart
document.addEventListener('DOMContentLoaded', function() {
    if (window.location.pathname === '/cart') { // Check if the current page is the cart page
        const quantityButtons = document.querySelectorAll('.qty-button');

        quantityButtons.forEach(button => {
            button.addEventListener('click', function() {
                // Perform any necessary actions here, such as updating the quantity
                // Then reload the page after 1 second
                setTimeout(function() {
                    location.reload();
                }, 1000); // 1000 milliseconds = 1 second
            });
        });
    }
});

//variant

